import React, { useEffect, useState } from 'react';
import './css/Register.css';
import Button from '@mui/material/Button';
import Table from '@mui/material/Table';
import Switch from '@mui/material/Switch';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/AddCircle';
import {CircularProgress, IconButton} from "@mui/material";
import TextField from "@mui/material/TextField";
import Cookies from "js-cookie";
import EditIcon from "@mui/icons-material/Edit";
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';
import Dialog from '@mui/material/Dialog';
import {
    Check, CheckCircle,
    CheckCircleOutlined,
    CheckCircleOutlineRounded,
    CheckCircleRounded, RemoveCircle,
    SmartToyTwoTone,
    X
} from "@mui/icons-material";
import {Link} from "react-router-dom";
import {ArrowRightIcon} from "@mui/x-date-pickers";
import InstallInstructions from "./InstallInstructions";
function LicensedMachines({onSwitchToListings}) {
    return <MachinesSection onSwitchToListings={onSwitchToListings}  />;
}

function MachinesSection({onSwitchToListings}) {
    const [machines, setMachines] = useState([]);
    const [newMachineId, setNewMachineId] = useState('');
    const [authToken, setAuthToken] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [loading, setLoading] = useState(false);
    const [isAdding, setIsAdding] = useState(false);
    const [showInstall, setShowInstall] = useState(false);


    const fetchMachines = () => {
        setLoading(true);
        const token = Cookies.get('auth');
        if (token) {
            setAuthToken(token);
            fetch(`../api/license/getLicenseComps?token=${encodeURIComponent(token)}`)
                .then(response => response.json())
                .then(data => {
                    setMachines(data);
                    setLoading(false);
                })
                .catch(error => {
                    console.error('Error fetching machines:', error);
                    setLoading(false);
                });
        } else {
            console.log('No token present in cookies.');
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchMachines();
    }, []);

    const handleAddMachine = () => {
        setIsAdding(true);
        const isExisting = machines.some(machine => machine.licenseEntity.machineId === newMachineId);
        if (isExisting) {
            setErrorMessage('Machine already added.');
            setIsAdding(false);
            return;
        }

        fetch(`../api/license/createLicense?token=${encodeURIComponent(authToken)}&m_id=${newMachineId}`, {
            method: 'GET', // Assuming GET, update if necessary
        })
            .then(response => {
                if (!response.ok) {
                    throw new Error('Machine does not exist');
                }
                return response.json();
            })
            .then(data => {
                setMachines(currentMachines => [...currentMachines, data]);
                setNewMachineId('');
                setErrorMessage('');
                setIsAdding(false);
            })
            .catch(error => {
                setErrorMessage(error.message);
                setIsAdding(false);
            });
    };

    const handleDeleteMachine = (machineId) => {
        // Construct the URL with machineId
        const url = `../api/license/delLicense?token=${encodeURIComponent(authToken)}&m_id=${machineId}`;

        // Perform the fetch request
        fetch(url, {
            method: 'GET', // Assuming GET, update if necessary
        })
            .then(response => {
                if (!response.ok) {
                    throw new Error('Failed to delete machine');
                }
                // Optionally, filter out the deleted machine from the machines state
                setMachines(currentMachines => currentMachines.filter(machine => machine.licenseEntity.machineId !== machineId));
            })
            .catch(error => {
                console.error('Error deleting machine:', error);
                alert('Error deleting machine');
            });
    };

    const handleShowInstall = () => {
        setShowInstall(!showInstall);
    }

    return (
        <div className="SectionEmbedded">
            <div className="SectionLtr">
              <span className="SectionBoxEmbedded">
                    <span className="SectionSubHeadingEmbedded">LICENSED MACHINES</span>
                  <span className="SectionSubHeadingExtraEmbedded "> AGENT CLIENT </span>
                  {loading ? (
                      // Show spinner in the center when loading
                      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100px' }}>
                          <CircularProgress />
                      </div>
                  ) : (
                      // Render machines list if not loading and machines are available
                      machines && machines.length > 0 && (
                          <div>
                              <div className="divLineDualGrad"></div>
                              <div className="table-container">
                                  <Table className="listingsTable">
                                      <TableHeader />
                                      <TableData machines={machines} onDelete={handleDeleteMachine} setMachines={setMachines} authToken={authToken} />
                                  </Table>
                              </div>
                              <div className="divLineDualGrad"></div>
                          </div>
                      )
                  )}
                    <div className="ButtonBarEmbedded">
                      <span className="_button_holder">
                        </span>
                        <span className="_button_holder">
                          <TextField error={Boolean(errorMessage)}
                                     helperText={errorMessage}
                                     id="new_machine_id"
                                     focused
                                     label="New Machine ID"
                                     size="small"
                                     value={newMachineId}
                                     onChange={(e) => {
                                         setNewMachineId(e.target.value);
                                         setErrorMessage(''); // Clear error message when user modifies input
                                     }}
                                     style={{ width: 200 }} // Adjust width as needed
                                     InputProps={{
                                          style: {
                                              fontSize: '1.2em', // Smaller font size for the input text
                                          },
                                      }}
                                     InputLabelProps={{
                                         style: {
                                             fontSize: '1.2em', // Smaller font size for the label
                                         },
                                     }}

                                     />
                      </span>
                        <span className="_button_holder">
                            {isAdding ? (
                                <CircularProgress size={32} /> // Adjust size to match the Add button's size
                            ) : (
                                <Button variant="contained" size="medium" startIcon={<AddIcon />} onClick={handleAddMachine}>
                                    Add
                                </Button>
                            )}
                        </span>
                        { machines && machines.length > 0 && machines.some(machine => machine.licenseEntity.vastEtlSub) && (
                            <span className="_button_holder">
                            <Button
                            color="success"
                            variant="outlined"
                            size="medium"
                            startIcon={<SmartToyTwoTone />}
                            onClick={handleShowInstall}>
                            INSTALL
                          </Button>
                            </span>
                            )}
                        <span className="_button_holder">
                          <Button
                              variant="text"
                              size="medium"
                              startIcon={<ArrowRightIcon />}
                              onClick={onSwitchToListings}
                          >
                            BACK To LISTED
                          </Button>
                        </span>
                    </div>
              </span>

            </div>
            <div className="SectionLtr">
                {showInstall && (

                    <>
                        <InstallInstructions token={authToken}/>
                    </>

                )}
            </div>
        </div>
    );
}

function TableHeader() {
    return (
        <tr className="trHeader">
            <td>Machine</td>
            <td>ETL</td>
            <td>ETL $</td>
            <td>Listing</td>
            <td>$ / GPU</td>
            <td>Total $ GPUs</td>
            <td>Total $ Rig</td>
            <td width='40px'>Status</td>
            <td>Updated</td>
            <td>Expires</td>
            <td colSpan="2">Actions</td>
        </tr>
    );
}

function TableData({ machines, onDelete, setMachines, authToken }) {
    const [originalMachines, setOriginalMachines] = useState({});
    const [editModes, setEditModes] = useState({});
    const [confirmDialog, setConfirmDialog] = useState({ open: false, machine: null, price: 0 });
    const [isVastEtlSub, setIsVastEtlSub] = useState(false);
    const [isListingSub, setIsListingSub] = useState(false);
    const [isEtlDisabled, setIsEtlDisabled] = useState(false);
    const [isListingDisabled, setIsListingDisabled] = useState(false);

    const handleEtlSwitchChange = (machineId, isEnabled) => {
            setMachines(currentMachines => currentMachines.map(machine => {
                if (machine.licenseEntity.machineId === machineId) {
                    console.log('Machine status updated successfully');
                    return {
                        ...machine,
                        licenseEntity: {
                            ...machine.licenseEntity,
                            vastEtlSub: isEnabled,
                            listingSub: !isEnabled ? false : machine.licenseEntity.listingSub
                        }
                    };
                }
                return machine;
            }));
    };

    const handleGpuSwitchChange = (machineId, isEnabled) => {
            setMachines(currentMachines => currentMachines.map(machine => {
                if (machine.licenseEntity.machineId === machineId) {
                    return {
                        ...machine,
                        licenseEntity: {
                            ...machine.licenseEntity,
                            listingSub: isEnabled,
                            vastEtlSub: isEnabled ? true : machine.licenseEntity.vastEtlSub
                        }
                    };
                }
                return machine;
            }))
    };

    const toggleEdit = (machineId) => {
        setMachines(currentMachines => currentMachines.map(machine => {
            if (machine.licenseEntity.machineId === machineId) {
                const isEditing = !machine.isEditable;
                if (isEditing) {
                    // Save the original state before editing
                    setOriginalMachines({
                        ...originalMachines,
                        [machineId]: { ...machine }
                    });
                } else {
                    // Clear the original state after editing
                    const newOriginals = { ...originalMachines };
                    delete newOriginals[machineId];
                    setOriginalMachines(newOriginals);
                }
                return { ...machine, isEditable: isEditing };
            }
            return machine;
        }));
    };

    const handleCancelEdit = (machineId) => {
        setMachines(currentMachines => currentMachines.map(machine => {
            if (machine.licenseEntity.machineId === machineId) {
                return { ...originalMachines[machineId], isEditable: false };
            }
            return machine;
        }));
        const newOriginals = { ...originalMachines };
        delete newOriginals[machineId];
        setOriginalMachines(newOriginals);
    };


    function handleSubmitChanges(machineId) {
        const machine = machines.find(m => m.licenseEntity.machineId === machineId);
        const original = originalMachines[machineId];
        let price = 0;
        if (original && !original.licenseEntity.vastEtlSub && machine.licenseEntity.vastEtlSub) {
            setIsListingSub(false);
            setIsListingSub(false);
            setIsVastEtlSub(true);
            price += machine.licenseEntity.vastEtlPrice;
        }
        if (original && !original.licenseEntity.listingSub && machine.licenseEntity.listingSub) {
            setIsVastEtlSub(true);
            setIsListingSub(true);
            price += machine.licenseEntity.listingPricePerGpu * machine.licenseEntity.numGpus;
        }
        if(machine.licenseEntity.listingSub) {
            setIsVastEtlSub(true);
            setIsListingSub(true);
            price = price.toFixed(2);
            setConfirmDialog({ open: true, machine, price });
            return;
        }

        if (original && original.licenseEntity.vastEtlSub && !machine.licenseEntity.vastEtlSub) {
            setIsEtlDisabled(true);
            setIsVastEtlSub(false);
        }
        if (original && original.licenseEntity.listingSub && !machine.licenseEntity.listingSub) {
            setIsListingDisabled(true);
            setIsListingSub(false);
            price += machine.licenseEntity.listingPricePerGpu * machine.licenseEntity.numGpus;
            price = price.toFixed(2);
            setConfirmDialog({ open: true, machine, price });
            return;
        }

        if( isEtlDisabled || (!machine.licenseEntity.listingSub && !isListingDisabled)) {
            handlePushChanges(machineId);
        }

    }

    function handlePushChanges(machineId) {
        const machineIndex = machines.findIndex(m => m.licenseEntity.machineId === machineId);
        if (machineIndex === -1) {
            console.error('Machine not found');
            return;
        }

        // Clone the current state to have a backup in case we need to revert
        const originalMachines = [...machines];
        const updatedMachine = { ...machines[machineIndex], isEditable: false }; // Exit edit mode

        // Optimistically update the UI
        setMachines(currentMachines =>
            currentMachines.map((m, index) => (index === machineIndex ? updatedMachine : m))
        );


        const licenseParams = updatedMachine.licenseEntity;
        const payload = {
            token: authToken,
            l_id: licenseParams.id,
            is_enabled: licenseParams.enabled,
            machine_id: licenseParams.machineId,
            gpu_name: licenseParams.gpuName,
            num_gpus: licenseParams.numGpus,
            is_vast_etl_sub: licenseParams.vastEtlSub,
            vast_etl_price: licenseParams.vastEtlPrice,
            is_listing_sub: licenseParams.listingSub,
            listing_price_per_gpu: licenseParams.listingPricePerGpu
        };

        // Convert payload to query parameters
        const queryParams = new URLSearchParams(payload).toString();
        const url = `../api/license/updateLicense?${queryParams}`;

        fetch(url, {
            method: 'GET', // Matching your original method; consider POST for sensitive data
        })
            .then(response => {
                if (!response.ok) {
                    throw new Error('Failed to update event preferences');
                }
                return response.json();
            })
            .then(data => {
                console.log('Event preferences updated successfully');
                // Optionally update state with response data if the API returns updated preferences
            })
            .catch(error => {
                console.error('Error updating event preferences:', error);
                // Revert to the original state since the update failed
                setMachines(originalMachines);
                alert('Failed to update event preferences');
            });
    }

    const handleConfirmProceed = () => {
        if (confirmDialog.machine) {
            toggleEdit(confirmDialog.machine.licenseEntity.machineId);
        }
        setConfirmDialog({ open: false, machine: null, price: 0 });
        Cookies.set("agent_section", "licensed");
        window.location.href = "../api/stripe/checkoutGpu?token=" + encodeURIComponent(Cookies.get("auth")) + "&m_id=" + confirmDialog.machine.licenseEntity.machineId;
    };

    const handleConfirmCancelStripe = () => {
        if (confirmDialog.machine) {
            toggleEdit(confirmDialog.machine.licenseEntity.machineId);
        }
        setConfirmDialog({ open: false, machine: null, price: 0 });
        var cancelUrl = "../api/license/cancelGpu?token=" + encodeURIComponent(Cookies.get("auth")) + "&m_id=" + confirmDialog.machine.licenseEntity.machineId;
        fetch(cancelUrl, {
            method: 'GET', // Assuming GET, update if necessary
        })
            .then(response => {
                if (!response.ok) {
                    throw new Error('Failed to cancel listing subscription');
                }
            })
            .catch(error => {
                console.error('Error cancelling listing sub:', error);
                alert('Error cancelling listing subscription.');
            });
    };

    const handleConfirmCancel = () => {
        if (confirmDialog.machine) {
            toggleEdit(confirmDialog.machine.licenseEntity.machineId);
        }
        setConfirmDialog({ open: false, machine: null, price: 0 });
    };

    const formatEpochToLocalTime = (epoch) => {
        if (!epoch) return ''; // Handle null or undefined
        // Assuming epoch is in milliseconds; if in seconds, multiply by 1000
        const date = new Date(Number(epoch));
        return date.toLocaleString('en-US', {
            year: 'numeric',
            month: 'numeric',
            day: 'numeric',

        });
    };



    return(
        <tbody>
        {machines.map(machine => (
            <tr key={machine.licenseEntity.machineId} style={{ backgroundColor: machine.isEditable ? '#305772' : 'transparent' }}>
                <td>
                    <input value={machine.licenseEntity.machineId} className="tableData"/>
                    <div className="tdGpuInfo">{`${machine.licenseEntity.gpuName} x ${machine.licenseEntity.numGpus}`}</div>

                </td>
                <td>
                    <Switch
                        size="small"
                        checked={machine.licenseEntity.vastEtlSub}
                        disabled={!machine.isEditable}
                        onChange={(e) => handleEtlSwitchChange(machine.licenseEntity.machineId, e.target.checked)}
                    />
                </td>
                <td>
                    <input value={machine.licenseEntity.vastEtlPrice == 0 ? '$0.00' : machine.licenseEntity.vastEtlPrice} className="tableData"/>
                    <div className="tdGpuInfo">{machine.licenseEntity.vastEtlPrice == 0 ? 'Promotion' : 'per machine'}</div>
                </td>
                <td>
                    <Switch
                        size="small"
                        checked={machine.licenseEntity.listingSub}
                        disabled={!machine.isEditable}
                        onChange={(e) => handleGpuSwitchChange(machine.licenseEntity.machineId, e.target.checked)}
                    />
                </td>
                <td>
                    <input value={'$' + machine.licenseEntity.listingPricePerGpu} className="tableData"/>
                    <div className="tdGpuInfo">{`avg $${machine.licensePriceDto.gpuNameAvgRentedPrice} tier ${machine.licensePriceDto.priceTier}`}</div>
                </td>
                <td>
                    <input value={'$' + (machine.licenseEntity.listingSub ? (machine.licenseEntity.listingPricePerGpu * machine.licenseEntity.numGpus).toFixed(2) : '0.00')} className="tableData"/>
                </td>
                <td>
                    <input value={'$' + (machine.licenseEntity.listingSub ? ((machine.licenseEntity.listingPricePerGpu * machine.licenseEntity.numGpus)
                        + machine.licenseEntity.vastEtlPrice).toFixed(2) : '0.00') } className="tableData"/>
                </td>
                <td>

                    <div className="tdHalfHeight">ETL {machine.licenseEntity.vastEtlSub ? <CheckCircleIcon style={{ fontSize: '1.2em', lineHeight: '1.3em', verticalAlign: 'middle', textAlign: 'left', color: "lightgreen" }}/> :
                        <RemoveCircle style={{ fontSize: '1.2em', lineHeight: '1.3em', verticalAlign: 'middle', textAlign: 'left', color: "orange" }}/>}</div>
                    <div className="tdHalfHeight">GPU {machine.licenseEntity.listingSub ? <CheckCircleIcon style={{ fontSize: '1.2em', lineHeight: '1.3em', verticalAlign: 'middle', textAlign: 'left', color: "lightgreen" }}/> :
                        <RemoveCircle style={{ fontSize: '1.2em', lineHeight: '1.3em', verticalAlign: 'middle', textAlign: 'left', color: "orange" }}/>}</div>
                </td>
                <td>
                    <input
                        value={formatEpochToLocalTime(
                            machine.licenseEntity.timeCreated === machine.licenseEntity.timeUpdated
                                ? machine.licenseEntity.timeCreated
                                : machine.licenseEntity.timeUpdated
                        )}
                        className="tableData"
                        readOnly
                    />
                    <div className="tdGpuInfo">{machine.licenseEntity.timeCreated == machine.licenseEntity.timeUpdated ? 'Created' : 'Updated'}</div>
                </td>
                <td>
                    <input value={machine.licenseEntity.enabled ? 'Perpetual' : 'Inactive'} className="tableData"/>
                    <div className="tdGpuInfo">{machine.licenseEntity.enabled ? 'Renews Monthly' : 'No charges'}</div>
                </td>
                {machine.isEditable ? (
                    <>
                        <td>
                            <IconButton color="success" size="small"
                                        onClick={() => handleSubmitChanges(machine.licenseEntity.machineId)}>
                                <CheckCircleIcon/>
                            </IconButton>
                        </td>
                        <td>
                            <IconButton color="error" size="small" onClick={() => handleCancelEdit(machine.licenseEntity.machineId)}>
                            <CancelIcon />
                            </IconButton>
                        </td>
                    </>
                ) : (
                    <>
                        <td>
                            <IconButton color="primary" size="small" onClick={() => toggleEdit(machine.licenseEntity.machineId)}>
                                <EditIcon />
                            </IconButton>
                        </td>
                        <td>
                            <IconButton color="primary" size="small" onClick={() => onDelete(machine.licenseEntity.machineId)}>
                                <DeleteIcon/>
                            </IconButton>
                        </td>
                    </>
                )}




            </tr>
        ))}
        <Dialog
            open={confirmDialog.open}
            onClose={handleConfirmCancel}
            PaperProps={{
                style: {
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    padding: '24px',
                },
            }}
        >
            {!isListingDisabled ? (
                <>
                    <h3 style={{ marginTop: 0, fontSize: '1.35rem', fontWeight: 500 }}>
                        Activate Listing Agent Subscription?
                    </h3>
                    <p style={{ fontSize: '.9rem', lineHeight: '1.1rem', margin: '16px 0' }}>
                        You are activating the{' '}
                        <b>{isVastEtlSub ? 'Vast ETL & Events' : ''}</b>{' '}
                        {isListingSub ? 'and' : ''}{' '}
                        <b>{isListingSub ? 'Listing Agent' : ''}</b> subscription for Machine ID{' '}
                        <b>{confirmDialog.machine?.licenseEntity.machineId}</b>. This will
                        increase your subscription costs by <b>${confirmDialog.price}</b> per
                        month (plus any applicable taxes).
                    </p>
                    <p style={{ fontSize: '1rem', margin: '8px 0' }}>Is this correct?</p>
                    <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '8px', marginTop: '16px' }}>
                        <Button onClick={handleConfirmCancel} color="primary" variant="outlined">
                            Cancel
                        </Button>
                        <Button
                            onClick={handleConfirmProceed}
                            color="primary"
                            variant="contained"
                        >
                            Pay via Stripe
                        </Button>
                    </div>
                </>
            ) : isListingDisabled ? (
                <>
                    <h3 style={{ marginTop: 0, fontSize: '1.35rem', fontWeight: 500 }}>
                        Cancel Listing Agent Subscription?
                    </h3>
                    <p style={{ fontSize: '.9rem', lineHeight: '1.1rem', margin: '16px 0' }}>
                        You are cancelling the <b>{isListingSub ? 'Listing Agent' : ''}</b>{' '}
                        subscription for Machine ID{' '}
                        <b>{confirmDialog.machine?.licenseEntity.machineId}</b>. This will lower
                        your monthly subscription costs by <b>${confirmDialog.price}</b> per
                        month (plus any applicable taxes).
                    </p>
                    <p style={{ fontSize: '1rem', margin: '8px 0' }}>Is this correct?</p>
                    <div style={{ display: 'flex', justifyContent: 'flex-end', gap: '8px', marginTop: '16px' }}>
                        <Button onClick={handleConfirmCancel} color="primary" variant="outlined" size="small">
                            Cancel
                        </Button>
                        <Button
                            onClick={handleConfirmCancelStripe}
                            color="primary"
                            variant="contained"
                            size="small"
                        >
                            Cancel Stripe Subscription
                        </Button>
                    </div>
                </>
            ) : (
                <>{  }
                </>)}
        </Dialog>
        </tbody>
    );
}

function AddButton({ onClick }) {
    return (
        <Button variant="contained" size="medium" startIcon={<AddIcon />} onClick={onClick}>
            Add
        </Button>
    );
}
function AgentLicensesButton() {

    return (
        <Button  variant="outlined" startIcon={< SmartToyTwoTone/>}>
            LISTED
        </Button>
    );
}


export default LicensedMachines;
